import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { SmallContainer } from 'app/components/container';
import { fontSecondary } from 'app/style/fonts';
import { spacing3, spacing5, spacing7, spacing9 } from 'app/style/spacing';

export const StyledChooseContainer = styled(SmallContainer)`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: ${spacing7};
    margin-bottom: ${spacing9};
`;

export const StyledSubTitle = styled(Typography)`
    font-family: ${fontSecondary};
    font-weight: bold;
    margin-top: ${spacing5};
`;

export const StyledText = styled(Typography)`
    padding: ${spacing3} 0;
`;
